import { Component, ViewChild } from '@angular/core';
import { MyDocumentsListingComponent } from '../my-documents-listing/my-documents-listing.component';
import { ActivatedRoute } from '@angular/router';
import { Subject, Subscription } from 'rxjs';

@Component({
  selector: 'app-results-page',
  templateUrl: './results-page.component.html',
  styleUrls: ['./results-page.component.scss'],
})
export class ResultsPageComponent {
  @ViewChild(MyDocumentsListingComponent)
  searchResultsRef!: MyDocumentsListingComponent;
  resultsCount: number = 0;
  filterByDocumentNumber: string = '';
  destroy$: Subscription;

  constructor(private route: ActivatedRoute) {
    this.destroy$ = this.route.queryParamMap.subscribe((result: any) => {
      if (result.params.docId) {
        this.filterByDocumentNumber = result.params.docId;
      }
    });
  }
  ngOnInit() {}
  onDocumentsListingLoad = (args: number): void => {
    this.resultsCount = args;
  };
  ngOnDestroy() {
    this.destroy$.unsubscribe();
  }
}
